import io from "socket.io-client";
import AxiosConfigs from "./axios";

const { REACT_APP_LINK_HOST: apiUrl } = AxiosConfigs;

// Prefer 127.0.0.1 over localhost so WS doesn't hit ::1 while the API
// listens on IPv4 only (listen(..., "0.0.0.0")).
const socketUrl = (apiUrl || "").replace(
  /^(https?:\/\/)localhost(?=[:/]|$)/i,
  "$1127.0.0.1"
);

// WebSocket first — prod runs multiple ECS tasks behind the ALB with no
// sticky sessions and no shared Socket.IO adapter. Long-polling opens on
// task A then POSTs to task B → 400 "Session ID unknown" and console spam.
// Polling remains as a fallback when WebSocket is blocked.
const socket = io(socketUrl || undefined, {
  path: "/socket.io",
  transports: ["websocket", "polling"],
  upgrade: true,
  reconnection: true,
  autoConnect: false,
});

export default socket;
